import React from 'react';
import BrandLogo from './BrandLogo';
import { XIcon, InstagramIcon, FacebookIcon, TikTokIcon, RedditIcon, DiscordIcon } from './SocialIcons';

const socials = [
  {
    name: 'X',
    href: 'https://x.com/chainkartapp?s=11&t=jbXPsA-nn7Xga1w6sPxQMg',
    Icon: XIcon,
  },
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/chainkartapp/',
    Icon: InstagramIcon,
  },
  {
    name: 'Discord',
    href: 'https://discord.gg/WRcgxGx3E',
    Icon: DiscordIcon,
  },
  {
    name: 'Facebook',
    href: 'https://www.facebook.com/profile.php?id=61592358209088',
    Icon: FacebookIcon,
  },
  {
    name: 'TikTok',
    href: 'https://www.tiktok.com/@chainkart?_r=1&_t=ZN-98H3ryNszbj',
    Icon: TikTokIcon,
  },
  {
    name: 'Reddit',
    href: 'https://www.reddit.com/user/Chainkart/?utm_source=share&utm_medium=web3x&utm_name=web3xcss&utm_term=1&utm_content=share_button',
    Icon: RedditIcon,
  },
];

const WaitlistFooter = () => {
  return (
    <footer className="relative bg-black border-t border-white/5">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-14 md:py-16">
        <div className="grid md:grid-cols-3 gap-10 items-start">
          <div className="md:col-span-2">
            <BrandLogo size={56} />
            <p className="mt-5 max-w-md text-sm text-neutral-400 leading-relaxed">
              The luxury Web3 marketplace. Shop premium brands, watch live drops, bid in
              high-stakes auctions — paid in your favorite crypto.
            </p>
            <div className="mt-6 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#39D353]/10 border border-[#39D353]/25">
              <span className="h-1.5 w-1.5 rounded-full bg-[#39D353] neon-dot" />
              <span className="text-[12px] tracking-wider uppercase text-[#39D353] font-semibold">
                Launching Q4 2026
              </span>
            </div>
          </div>

          <div className="flex flex-col md:items-end gap-6">
            <a
              href="mailto:hello@chainkart.app"
              className="text-sm text-neutral-400 hover:text-white transition-colors"
            >
              Contact us
            </a>

            <div className="flex md:justify-end flex-wrap gap-2.5">
              {socials.map(({ name, href, Icon }) => (
                <a
                  key={name}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`ChainKart on ${name}`}
                  title={name}
                  className="h-10 w-10 rounded-full bg-white/5 hover:bg-[#39D353]/15 border border-white/10 hover:border-[#39D353]/40 hover:text-[#39D353] flex items-center justify-center text-neutral-300 transition-colors"
                >
                  <Icon size={15} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs text-neutral-500">
            &copy; {new Date().getFullYear()} ChainKart. All rights reserved.
          </div>
          <div className="text-[11px] tracking-[0.2em] uppercase text-neutral-600">
            Built for the on-chain generation
          </div>
        </div>
      </div>
    </footer>
  );
};

export default WaitlistFooter;
